var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedBulbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2377_19062",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2377_19062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9969 26.1984C15.5635 26.1984 15.1552 26.0943 14.7719 25.8859C14.3885 25.6776 14.1052 25.3818 13.9219 24.9984H13.5969C13.0969 24.9984 12.6719 24.8234 12.3219 24.4734C11.9719 24.1234 11.7969 23.6984 11.7969 23.1984V19.4484C10.8469 18.7818 10.1094 17.9318 9.58437 16.8984C9.05937 15.8651 8.79688 14.7651 8.79688 13.5984C8.79688 11.5984 9.49687 9.89844 10.8969 8.49844C12.2969 7.09844 13.9969 6.39844 15.9969 6.39844C17.9969 6.39844 19.6969 7.09844 21.0969 8.49844C22.4969 9.89844 23.1969 11.5984 23.1969 13.5984C23.1969 14.7651 22.9344 15.8651 22.4094 16.8984C21.8844 17.9318 21.1469 18.7818 20.1969 19.4484V23.1984C20.1969 23.6984 20.0219 24.1234 19.6719 24.4734C19.3219 24.8234 18.8969 24.9984 18.3969 24.9984H18.0469C17.8635 25.3818 17.5844 25.6776 17.2094 25.8859C16.8344 26.0943 16.4302 26.1984 15.9969 26.1984ZM13.5969 23.1984H18.3969V21.9984H13.5969V23.1984ZM13.5969 20.7984H18.3969V19.5984H13.5969V20.7984ZM12.6469 17.7984H15.3969V15.0484L13.1719 12.8234L14.0219 11.9734L15.9969 13.9484L17.9719 11.9734L18.8219 12.8234L16.5969 15.0484V17.7984H19.3469C19.9802 17.2818 20.4802 16.6609 20.8469 15.9359C21.2135 15.2109 21.3969 14.4318 21.3969 13.5984C21.3969 12.0984 20.8719 10.8234 19.8219 9.77344C18.7719 8.72344 17.4969 8.19844 15.9969 8.19844C14.4969 8.19844 13.2219 8.72344 12.1719 9.77344C11.1219 10.8234 10.5969 12.0984 10.5969 13.5984C10.5969 14.4151 10.7802 15.1901 11.1469 15.9234C11.5135 16.6568 12.0135 17.2818 12.6469 17.7984Z",
    fill: "#BC1919"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBulbIcon);
export default __webpack_public_path__ + "static/media/red-bulb-icon.feca4d575008647bdddca71e33df7d2f.svg";
export { ForwardRef as ReactComponent };